import initialState from './initialstate';
import * as types from '../actions/actiontypes';

/**
 * This reducer function handles all the actions related to the global navigation bar.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function globalNavReducer(state = initialState.globalNavState, action) {
	switch (action.type) {
		case types.UPDATE_GLOBAL_NAV_ACTIVE_ICON:
			return {
				refreshActiveIcon: true
			};
		default:
			return state;
	}
}
